import React from 'react';
import { NewCart } from '@/components/NewCart/Cart';
import { ModalAgeRestriction } from '@/components/ModalAgeRestriction';
import type { CartQuery as CartQueryType } from 'lib/api';
import type { GetServerSideProps, NextPage } from 'next';
import { useCartStore } from 'store/cart';
import { getCartData } from '@/api/getCartData';
import { getLiteCampaign } from '@/api/getLiteCampaign';
import { subscribeToCampaign } from '@/api/subscribeToCampaign';
import { ProductListCart } from "@/components/ProductList/ProductListCart";
import { fetchCart, fetchProducts } from 'api/requests';
import { Cart, Product } from 'interfaces';
import Products from '@/components/pages/Products/Products';

const Home: NextPage<{ cart: CartQueryType['Cart']; products: Product[]; cartInstance: Cart, referer: string }> = ({ cart, cartInstance, products, referer }) => {
  const { setUnderAge, theme } = useCartStore();
  const [ageModal, setAgeModal] = React.useState(true);

  // @ts-ignore
  const providerProducts = cartInstance.products.map(({ id, name, description, images, variants }) => ({
    id,
    cartId: cartInstance.id,
    title: name,
    description,
    // @ts-ignore
    price: variants.map(({ price }) => price.amount).join('/'),
    // @ts-ignore
    imageUrls: images.map(({ url }) => url),
    isAuction: false,
    bids: [],
    auction: null,
    largestBid: null,
  }));

  // if (cartInstance && products.length) {
  //   return <Products cart={cartInstance} products={[...products, ...providerProducts]} />;
  // }

  if (theme === 'products') {
    return <ProductListCart cart={cart} referer={referer} />;
  }

  return (
    <>
      {<NewCart cart={cart} referer={referer} products={products} />}
      {ageModal && cart.slug === 'komos' && (
        <ModalAgeRestriction
          cart={cart}
          open={true}
          onClose={() => setAgeModal(false)}
          underAge={() => {
            setAgeModal(false);
            setUnderAge(true);
          }}
        />
      )}
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const hostname = String(context?.req?.headers?.['x-forwarded-host'] ?? process.env.VERCEL_URL);
  const referer = context?.query?.origin || context?.req?.headers?.referer || 'Unknown';

  const identifier = {
    creator_slug: hostname.split('.')[0],
    slug: String(context.query.slug)
  };

  try {
    const liteCampaign = await getLiteCampaign(identifier);
    if (liteCampaign) {
      return await subscribeToCampaign(liteCampaign, context)
    }

    const { data } = await getCartData(identifier);
    const cart = await fetchCart(identifier.creator_slug, identifier.slug);
    const products = await fetchProducts(cart.id);

    return {
      props: {
        cart: data,
        cartInstance: cart,
        products,
        referer
      },
    };
  } catch (e) {
    console.log(e);
    return {
      notFound: true,
      props: {},
    };
  }
};

export default Home;
